
import React, { useState } from 'react';
import MobileLayout from "@/components/layout/MobileLayout";
import { useAuth } from '@/contexts/SupabaseAuthContext';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import RequestAccessForm from '@/components/auth/RequestAccessForm';
import { Lock } from 'lucide-react';
import AccessStatusMessage from '@/components/auth/AccessStatusMessage';
import AccessDeniedFooter from '@/components/auth/AccessDeniedFooter';


const AccessDenied: React.FC = () => {
  const { user, isAuthenticated } = useAuth();
  const [showForm, setShowForm] = useState(false);
  const isDevEnv = !import.meta.env.PROD;
  
  return (
    <MobileLayout hideNavigation>
      <div className="flex flex-col items-center justify-center min-h-screen p-4">
        <div className="w-full max-w-md">
          
          <Card className="w-full">
            <CardHeader className="space-y-1">
              <div className="flex justify-center mb-4">
                <div className="h-16 w-16 bg-red-100 rounded-full flex items-center justify-center">
                  <Lock className="h-8 w-8 text-red-500" />
                </div>
              </div>
              <CardTitle className="text-2xl text-center">Access Denied</CardTitle>
            </CardHeader>
            
            <CardContent className="space-y-4 text-center">
              <div className="bg-amber-50 p-4 rounded-md border border-amber-200">
                <div className="flex items-center">
                  <Lock className="h-5 w-5 text-amber-500 mr-2" />
                  <h3 className="font-medium text-amber-800">Access Required</h3>
                </div>
                <p className="text-sm text-amber-700 mt-1">
                  You need proper access permissions to view this content.
                </p>
              </div>
              
              <AccessStatusMessage 
                isAuthenticated={isAuthenticated} 
                userEmail={user?.email} 
              />
              
              {!showForm && (
                <Button 
                  onClick={() => setShowForm(true)}
                  className="w-full mt-4"
                >
                  Request Access
                </Button>
              )}
              
              {showForm && <RequestAccessForm />}
            </CardContent>
            
            <CardFooter className="flex flex-col space-y-2">
              <AccessDeniedFooter />
            </CardFooter>
          </Card>
        </div>
      </div>
    </MobileLayout>
  );
};

export default AccessDenied;
